import $ from 'jquery';

import application from 'application/application';

const controller = 'DefaultKeywordsKeywordsDetailsController';

application

	.controller(controller, ['$scope', '$http', '$state', '$stateParams', 'API', 'helper', ($scope, $http, $state, $stateParams, API, helper) => {

		/** Instância de armazenamento de resposta. */
		$scope.keywords = helper.responseStore()

			.setItemsPerPage(10);

		/** Define a página atual com base na URL. */

		if ($stateParams.paginaAtual !== undefined)

			$scope.keywords.setCurrentPage($stateParams.paginaAtual);

		let

			/** Lista de filtros possíveis. */
			keywordsFiltersNames = [
				'q',
				'visualizada',
				'favorita',
				'arquivada',
				'dataPublicacao',
				'idPalavraChave',
				'idDiario',
				'vara',
				'comarca'
			];

		/** Define os filtros informados na URL. */
		keywordsFiltersNames.forEach(name => {

			let value = $stateParams[name];

			if (value !== undefined)

				$scope.keywords.setFilter(name, value);

		});

		/** Define uma cópia dos filtros atuais para ser usados como modelo. */
		$scope.filtersKeywords = helper.cloneSimpleObject($scope.keywords.getFilters());

		/** Define valores padrões padrões para criar um item */
		const

			defaultKeywords = {
				nome : '',
				ativo: true,
				aplicacoes: []
			};

		/** Cria item em vazio para ser preenchido. */
		$scope.emptyEmployeeProfile = helper.cloneSimpleObject(defaultKeywords);

		/** Cria item em vazio para ser preenchido. */
		$scope.editableEmployeeProfile = {
			nome: '',
			ativo: '',
			aplicacoes: []
		};

		/**
		 * Recupera perfis.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.keywords = helper.responseStore();
		 *
		 * // Recupera as aplicações.
		 * $scope.recordKeywords($scope.keywords);
		 */
		$scope.recordKeywords = responseStore => {

			$http({
				...helper.http(API.userKeywords, 'GET'),
				params: {
					...helper.httpFields([
						'id'
					]),
					paginaAtual: responseStore.getCurrentPage(),
					registrosPorPagina: responseStore.getItemsPerPage(),
					...responseStore.getFilters()
				}
			})

				.then(response => {

					responseStore.setItems(response.data.itens);

					$scope.keywordsLength = response.data.paginacao.totalRegistros;

					$scope.keywordsPagesLength = Math.ceil($scope.keywordsLength / responseStore.getItemsPerPage());

				})

				.finally(() => responseStore.setReady(true));

		};

		$scope.recordKeywords($scope.keywords);

		/**
		 * Filtra os perfis de colaboradores.
		 *
		 * @param {Object} filters - Objeto com filtros.
		 */
		$scope.filterKeywords = filters => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			Object.keys(filters).forEach(filter => params[filter] = filters[filter]);

			$state.go($state.current.name, params, { inherit: false, reload: 'root.default.keywords' });

		};

		/**
		 * Remove um filtro dos perfis de colaboradores.
		 *
		 * @param {String} filter - Filtro a ser removido.
		 */
		$scope.removeKeywordsFilter = filter => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			delete params[filter];

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Limpa os filtros dos perfis de colaboradores.
		 */
		$scope.clearKeywordsFilters = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			keywordsFiltersNames.forEach(name => delete params[name]);

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Verifica se existe uma página anterior à atual.
		 */
		$scope.hasKeywordsPrevPage = () => ($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

		/**
		 * Navega para a primeira página.
		 */
		$scope.recordKeywordsFirstPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a página anterior.
		 */
		$scope.recordKeywordsPrevPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			let currentPage = params.paginaAtual ? Number(params.paginaAtual): 1;

			params.paginaAtual = currentPage > 1 ? currentPage - 1 : 1;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a próxima página.
		 */
		$scope.recordKeywordsNextPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = params.paginaAtual ? Number(params.paginaAtual) + 1 : 2;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 *
		 */
		$scope.favoriteKeywords = (responseStore, keywords) => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			$http({
				...helper.http(API.keywords, 'favorite'),
				method: 'PUT',
				data: {
					itens: keywords
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(keywords))

				.finally(() => responseStore.setItemsAsNotBusy(keywords));

		};

		/**
		 *
		 */
		$scope.unfavoriteKeywords = (responseStore, keywords) => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			$http({
				...helper.http(API.keywords, 'unfavorite'),
				method: 'PUT',
				data: {
					itens: keywords
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(keywords))

				.finally(() => responseStore.setItemsAsNotBusy(keywords));

		};

		/**
		 *
		 */
		$scope.printKeywords = keywords => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			$state.go('root.default.keywords.keywordsDetails', {
				keywordsIDs: keywords.map(item => item.id).join(','),
				print: true
			});

		};

		/**
		 *
		 */
		$scope.downloadKeywords = keywords => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			window.open(helper.http(API.keywords, 'download').url + '?IDs=' + keywords.map(item => item.id).join(','), '_self');

		};

		/**
		 *
		 */
		$scope.archiveKeywords = (responseStore, keywords) => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			$http({
				...helper.http(API.keywords, 'archive'),
				method: 'PUT',
				data: {
					itens: keywords
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(keywords))

				.finally(() => responseStore.setItemsAsNotBusy(keywords));

		};

		/**
		 *
		 */
		$scope.restoreKeywords = (responseStore, keywords) => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			$http({
				...helper.http(API.keywords, 'restore'),
				method: 'PUT',
				data: {
					itens: keywords
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(keywords))

				.finally(() => responseStore.setItemsAsNotBusy(keywords));

		};

		/**
		 *
		 */
		$scope.forwardKeywords = (responseStore, keywords) => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			$http({
				...helper.http(API.keywords, 'forward'),
				method: 'POST',
				data: {
					itens: keywords
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(keywords))

				.finally(() => responseStore.setItemsAsNotBusy(keywords));

		};

		/**
		 *
		 */
		$scope.setKeywordsAsRead = (responseStore, keywords) => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			$http({
				...helper.http(API.keywords, 'setAsRead'),
				method: 'PUT',
				data: {
					itens: keywords
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(keywords))

				.finally(() => responseStore.setItemsAsNotBusy(keywords));

		};

		/**
		 *
		 */
		$scope.setKeywordsAsUnread = (responseStore, keywords) => {

			if (!Array.isArray(keywords)) keywords = [ keywords ];

			$http({
				...helper.http(API.keywords, 'setAsUnread'),
				method: 'PUT',
				data: {
					itens: keywords
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(keywords))

				.finally(() => responseStore.setItemsAsNotBusy(keywords));

		};

		/**
		 * Atualiza uma ou mais aplicações.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 * @param {Object[]|Object} items - Aplicação(ões) a ser(em) atualizada(s).
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.keywords = helper.responseStore();
		 *
		 * // Atualiza o valor `foo` da aplicação de ID 0.
		 * $scope.updateKeywords($scope.keywords, {id: 0, foo: true});
		 *
		 * // Atualiza o valor `foo` das aplicações de ID's 0 e 1.
		 * $scope.updateKeywords($scope.keywords, [{id: 0, foo: true}, {id: 1, foo: true}]);
		 */
		$scope.updateKeywords = (responseStore, items) => {

			responseStore.setItemsAsBusy(items);

			$('.modal').modal('hide');

			/** Caso `items` seja um unico item, cria um `Array` para ele. */
			if (!Array.isArray(items)) items = [ items ];

			$http({
				...helper.http(API.keywords, 'PUT'),
				data: {
					itens: items
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'))

				.finally(() => responseStore.setItemsAsNotBusy(items));

		};

		/** Exibe o modal para edição de aplicação. */
		$scope.showEmployeeProfilesModal = (responseStore, item, id) => {

			const

				showModal = () => {

					$('#' + id)

						.modal('show')

						.off('hidden.bs.modal')

						.on('hidden.bs.modal', () => {

							responseStore

								.rowbackItems(item)

								.setItemAsNotEditable(item);

							if (!$scope.$$phase) $scope.$apply();

						});

				};

			responseStore

				.setItemAsEditable(item)

				.setSiblingItemsAsNotEditable(item);

			$scope.editableEmployeeProfile = responseStore.getItems().find(value => value.__editable__);

			if (!item.aplicacoes)

				$scope.recordEmployeeProfileDetails(responseStore, item, showModal);

			else showModal();

		};

	}]);

export default controller;
